import {Type, ajax} from 'main.core';

export class BudgetRecalculate
{
	/**
	 * Start recalculate project budget
	 *
	 * @param      int      projectId  Project identifier
	 * @return     Promise
	 */
	static forProject( projectId )
	{
		return (new Promise((resolve, reject)=>{
			BudgetRecalculate.startProcess('PROJECT', projectId).then(
				(response) => {
					resolve(response);
				},
				(response) => {
					reject(response);
				},
			);
		}));
	}

	/**
	 * Start recalculate stage budget
	 *
	 * @param      int      stageId  Stage identifier
	 * @return     Promise
	 */
	static forStage( stageId )
	{
		return (new Promise((resolve, reject)=>{
			BudgetRecalculate.startProcess('STAGE', stageId).then(
				(response) => {
					resolve(response);
				},
				(response) => {
					reject(response);
				},
			);
		}));
	}

	/**
	 * Start recalculate job budget
	 *
	 * @param      int      jobId  Job identifier
	 * @return     Promise
	 */
	static forJob( jobId )
	{
		return (new Promise((resolve, reject)=>{
			BudgetRecalculate.startProcess('JOB', jobId).then(
				(response) => {
					resolve(response);
				},
				(response) => {
					reject(response);
				},
			);
		}));
	}

	/**
	 * Starts a process to recalculate entity
	 *
	 * @param      string   entityType  The entity type
	 * @param      integer  entityId    The entity identifier
	 * @return     Promise
	 */
	static startProcess( entityType, entityId )
	{
		return ajax.runAction(
			"fusion:project.Budget.recalculateEntity",
			{
				data:{
					entityType: entityType,
					entityId:   entityId
				}
			}
		);
	}
}